define.alias("shared/components/shared/upgrade/plan-highlight", "settings/components/shared/upgrade/plan-highlight");